export enum BetDirection {
  BACK = "BACK",
  LAY = "LAY",
}
